module.exports = __webpack_public_path__ + "static/media/redemption.096e0f23.png";